import React, { useCallback, useEffect, useState } from 'react';
import { Row, Col, Select, Spin, Radio, notification, message } from 'antd';
import FormInput from 'components/FormInput';
import Form, { FormInstance } from 'antd/lib/form';
import DF from 'DisplayFramework';
import ThirdPartyInput from 'components/ThirdPartyInput';
import { PropThirdPartyResponse } from 'services/proposal';
import { useQuery } from 'react-query';
import * as finEngine from 'services/finEngine';
import {
  FinConElementResponse,
  getFinModificationValidByCtrid,
  findFinCTByAnyRefOrStatusOrDate,
  FindFinCTByAnyRefOrStatusOrDateParams,
  getFinModificationByModid,
} from 'services/fincontract';

import BankAccountListSelect from 'pages/ThirdParty/ThirdPartyDetail/Components/BankAccListSelect';
import AddresseListSelect from 'pages/ThirdParty/ThirdPartyDetail/Components/AddressesListSelect';
import { shouldUpdateCompare } from 'utils/utils2';
import Value from 'components/Value';
import PricingListFilteredSelect from 'components/PricingListFilteredSelect';
import { toCurrency } from 'utils/utils';
import TextArea from 'antd/lib/input/TextArea';
import InputCurrency from 'components/InputCurrency/InputCurrency';
import { PricingResponse } from 'services/pricing';
import ParListSelect from 'components/ParListSelect/ParListSelect';
export type TabContractTransferProps = {
  objectid: number;
  object: string;
  form?: FormInstance;
  data: Array<PropThirdPartyResponse>;
  setSuccessful?: any;
};
const TabContractTransfer = ({
  objectid,
  object,
  data,
  form,
  setSuccessful,
}: TabContractTransferProps) => {
  // eslint-disable-next-line no-unused-vars
  const [state, setState] = useState({
    isLoading: false,
    isModSelected: false,
    newDuration: 0,
    effectDate: '',
    currcode: 'EUR',
    feesAmount: 0,
    feesFormula: '',
    newElements: [] as FinConElementResponse[],
  });
  const role = localStorage.getItem('userrole');
  const initialSearchParams: FindFinCTByAnyRefOrStatusOrDateParams = {
    branchid: 0,
    brokername: '',
    clientname: '',
    ctphase: '',
    ctreference: '',
    ctstatus: '',
    datemax: '',
    datemin: '',
    marketingid: 0,
    network: '',
    offerid: 0,
    prcode: '',
    propreference: '',
    tprefbroker: '',
    tpidbroker: 0,
    clientreference: '',
    ctrid: objectid ?? 0,
  };
  const [searchParams, setSearchParams] =
    useState<FindFinCTByAnyRefOrStatusOrDateParams>(initialSearchParams);

  const { data: contracts, isFetching } = useQuery(
    ['findPropByAnyRefOrStatusOrDate', searchParams],
    () =>
      findFinCTByAnyRefOrStatusOrDate(searchParams)
        .then((res) => res.list || [])
        .catch((error) => {
          notification.error({
            description: error.message,
            message: 'Proposal Service is not available',
          });
          return [];
        }),
    {
      staleTime: 60 * 1000,
    }
  );

  useEffect(() => {
    setSuccessful(isFetching);
  }, [isFetching]);

  useEffect(() => {
    if (contracts && contracts.length > 0) {
      form?.setFieldsValue({
        event: 'TabContractTransfer',
        objectreference: contracts[0]?.ctreference,
        currcode: contracts[0]?.currcode,
        currentstatus: contracts[0]?.statuslabel,
        cterentalamount: contracts[0]?.cterentalamount ?? 0,
        totalunpaidamount: contracts[0]?.totalunpaidamount ?? 0,
        totaloutstandingamount: contracts[0]?.totaloutstandingamount ?? 0,
        newoutstanding: contracts[0]?.totaloutstandingamount ?? 0,
        newrental: contracts[0]?.cterentalamount ?? 0,
        totalnotinvoicedrental: contracts[0]?.totalnotinvoicedrental ?? 0,
        tpidOldClient: {
          tpid: contracts[0]?.tpidclient,
          tpname: contracts[0]?.clientname,
          tpreference: contracts[0]?.clientreference,
        },
      });
    }
  }, [contracts]);

  const resetToManual = () => {
    form?.resetFields();
    if (contracts && contracts.length > 0) {
      form?.setFieldsValue({
        event: 'TabContractTransfer',
        objectreference: contracts[0]?.ctreference,
        currcode: contracts[0]?.currcode,
        currentstatus: contracts[0]?.statuslabel,
        cterentalamount: contracts[0]?.cterentalamount ?? 0,
        totalunpaidamount: contracts[0]?.totalunpaidamount ?? 0,
        totaloutstandingamount: contracts[0]?.totaloutstandingamount ?? 0,
        newoutstanding: contracts[0]?.totaloutstandingamount ?? 0,
        newrental: contracts[0]?.cterentalamount ?? 0,
        totalnotinvoicedrental: contracts[0]?.totalnotinvoicedrental ?? 0,
        tpidOldClient: {
          tpid: contracts[0]?.tpidclient,
          tpname: contracts[0]?.clientname,
          tpreference: contracts[0]?.clientreference,
        },
      });
    }
  };

  /* const notInvoicedSchedule = contract?.conElements
    ?.find((e) => e.ctetype === 'FIN')
    ?.conElemSchedules.filter((s) => s.ciid === null);
  const offerid = contract?.offerid;

  const optionDates = notInvoicedSchedule?.map((e, index) => (
    <option key={index} value={e.ctsduedate.toString()}>
      {e.ctsduedate}
    </option>
  ));
*/

  const updateState = useCallback(
    (values) => {
      setState((prev) => ({ ...prev, ...values }));
    },
    [setState]
  );

  const handleFinModSelect = (finmod: number) => {
    if (finmod === undefined) {
      updateState({ isModSelected: false });
      return;
    }

    updateState({ isLoading: true });

    let query = getFinModificationByModid({ modid: finmod });

    query.then((response) => {
      if (response.code !== '200') {
        return;
      }
      const res = response.data;

      form?.setFieldsValue({
        mode: 'REAL',

        effectDate: res.simulParams.filter(
          (item) => item.parcode === 'EFFECTDATE' && item.partype === 'IN'
        )[0].newvalue,

        tpidNewClient: {
          tpid: Number(
            res.simulParams.filter(
              (item) => item.parcode === 'NEWCLIENT' && item.partype === 'IN'
            )[0].newvalue
          ),
          tpname: res.simulParams.filter(
            (item) => item.parcode === 'NEWCLIENT' && item.partype === 'IN'
          )[0].parcomment,
          tpreference: ' ',
        },

        tpadridNewClient: Number(
          res.simulParams.filter(
            (item) => item.parcode === 'NEWADR' && item.partype === 'IN'
          )[0]?.newvalue
        ),

        tpbkidNewClient: Number(
          res.simulParams.filter(
            (item) => item.parcode === 'NEWBK' && item.partype === 'IN'
          )[0]?.newvalue
        ),

        feesAmount: res.simulParams.filter(
          (item) => item.parcode === 'FEESAMNT' && item.partype === 'IN'
        )[0]?.newvalue,

        feesFormula: res.simulParams.filter(
          (item) => item.parcode === 'FEESFORM' && item.partype === 'IN'
        )[0]?.newvalue,

        reason: res.simulParams.filter(
          (item) => item.parcode === 'REASON' && item.partype === 'IN'
        )[0]?.newvalue,
      });

      updateState({
        isModSelected: true,
      });

      updateState({ isLoading: false });
    });
  };

  const calculateFees = (pricing?: PricingResponse) => {
    finEngine
      .calculateServiceWithStep({
        servReq: {
          finSchedule: [],
          inDownPayment: 0,
          inFinAmount: form?.getFieldValue('totaloutstandingamount') ?? 0,
          inFollowGP: true,
          inGPDuration: 0,
          inPstype: pricing?.ctecategory ?? '',
          inRoudingAmount: 2,
          inServcalculationmethod:
            pricing?.serviceResponse.servcalculationmethod ?? '',
          inServfixedamount: pricing?.serviceResponse.servfixedamount ?? 0,
          inServiceduration: pricing?.serviceResponse.servduration ?? '',
          inServpercentage: pricing?.serviceResponse.servpercentage ?? 0,
          inTaxcode: pricing?.taxcode ?? '',
          inTaxrate: 20,
          inDuration: 0,
          inInvestAmount: form?.getFieldValue('totaloutstandingamount') ?? 0,
          inAssetAmount: form?.getFieldValue('totaloutstandingamount') ?? 0,
          inServperiodicity: pricing?.serviceResponse.servperiodicity ?? '1',
          inServDurationFree: pricing?.serviceResponse.servdurationdefault ?? 1,
          inStartDate: form?.getFieldValue('effectDate'),
          inServbasis: pricing?.serviceResponse.servbasis ?? 'FLAT',

          inCalculatedamountbasis:
            pricing?.serviceResponse.calculatedamountbasis ?? 'FINANCING',

          inMarginoncalcultedamount:
            pricing?.serviceResponse.marginoncalulatedamount ?? 0,
          inAdditionalcostaftermargin:
            pricing?.serviceResponse.additionalcostaftermargin ?? 0,

          servStep: pricing?.serviceStepList ?? [],
        },
      })
      .then((res) => {
        if (res.success) {
          message.success('Service - ' + res.message);

          form?.setFieldsValue({
            feesAmount: res.installmentamount,
            feesTax: (res.installmentamount * (pricing?.taxrate ?? 0)) / 100,
            feesTaxcode: pricing?.taxcode,
            feesTaxrate: pricing?.taxrate,
            feestype: pricing?.ctetype,
            feescategory: pricing?.ctecategory,
          });
        }
      });
  };

  const { data: modList } = useQuery(
    ['getFinModificationValidByCtrid', { ctrid: objectid }],
    () =>
      getFinModificationValidByCtrid({
        ctrid: objectid,
        modevent: 'TRANSFERCT',
      }).then((res) => res.list),
    { refetchOnMount: true }
  );

  const optionsMode = [
    { label: 'Simulation', value: 'SIMUL' },
    {
      label: 'Real',
      value: 'REAL',
      style:
        form?.getFieldValue('mode') === 'REAL'
          ? { background: 'black', color: 'white' }
          : {},
    },
  ];

  const optionModListValid = modList?.map((e, index) => (
    <Select.Option key={index} value={e.modid}>
      {e.modcomment}
    </Select.Option>
  ));

  return (
    <DF.Provider pagcode="tabtptransfer" entity={object} entityid={objectid}>
      <Spin spinning={isFetching}>
        <Form
          labelCol={{ span: 8 }}
          labelAlign="left"
          wrapperCol={{ span: 10 }}
          form={form}
        >
          <Row gutter={8}>
            <Col span={12}>
              <FormInput
                name="mode"
                rules={[{ required: true }]}
                labelAlign="left"
                initialValue="SIMUL"
                col
                md={24}
              >
                <Radio.Group
                  options={optionsMode}
                  defaultValue="SIMUL"
                  optionType="button"
                  disabled={state.isModSelected}
                />
              </FormInput>
              <FormInput col md={24} name="tpidOldClient">
                <ThirdPartyInput role="CLIENT" onlytpid display />
              </FormInput>
              <FormInput col md={24} name="currentstatus">
                <Value />
              </FormInput>
              <FormInput col md={24} name="cterentalamount">
                <Value
                  formatter={() =>
                    toCurrency(
                      form?.getFieldValue('cterentalamount'),
                      contracts ? contracts[0]?.currcode : ''
                    )
                  }
                />
              </FormInput>
              <FormInput col md={24} name="totalunpaidamount">
                <Value
                  formatter={() =>
                    toCurrency(
                      form?.getFieldValue('totalunpaidamount'),
                      contracts ? contracts[0]?.currcode : ''
                    )
                  }
                />
              </FormInput>
              <FormInput col md={24} name="totaloutstandingamount">
                <Value
                  formatter={() =>
                    toCurrency(
                      form?.getFieldValue('totaloutstandingamount'),
                      contracts ? contracts[0]?.currcode : ''
                    )
                  }
                />
              </FormInput>
              <FormInput col md={24} name="totalnotinvoicedrental">
                <Value
                  formatter={() =>
                    toCurrency(
                      form?.getFieldValue('totalnotinvoicedrental'),
                      contracts ? contracts[0]?.currcode : ''
                    )
                  }
                />
              </FormInput>
              <Col md={24}></Col>
              <FormInput col name="reason" xl={24} rules={[{ required: true }]}>
                <ParListSelect
                  parcode="CTTRREAS"
                  allowAddValue={role === 'ADMIN'}
                  disabled={state.isModSelected}
                />
              </FormInput>
            </Col>

            <Col span={12}>
              <Form.Item shouldUpdate={shouldUpdateCompare('mode')} noStyle>
                {({ getFieldValue }) => (
                  <FormInput
                    col
                    md={24}
                    name="modid"
                    labelAlign="left"
                    rules={[{ required: getFieldValue('mode') === 'REAL' }]}
                  >
                    <Select
                      allowClear
                      style={{ width: '100%' }}
                      onChange={(e: number) => handleFinModSelect(e)}
                      onClear={() => {
                        resetToManual();
                      }}
                    >
                      {optionModListValid}
                    </Select>
                  </FormInput>
                )}
              </Form.Item>
              <FormInput col md={24} name="tpidNewClient">
                <ThirdPartyInput role="CLIENT" disabled={state.isModSelected} />
              </FormInput>
              <Form.Item shouldUpdate={() => true} noStyle>
                {({ getFieldValue }) => {
                  const tpid = getFieldValue('tpidNewClient')?.tpid;

                  return (
                    <FormInput col md={24} name="tpadridNewClient">
                      <AddresseListSelect
                        params={{ tpid: tpid ?? 0 }}
                        onSelected={(e) =>
                          form?.setFieldsValue({
                            adrnew:
                              e.tpmainadrstreet1 + ' ' + e.tpmainadrcitylabel,
                          })
                        }
                        disabled={state.isModSelected}
                      />
                    </FormInput>
                  );
                }}
              </Form.Item>

              <Form.Item shouldUpdate={() => true} noStyle>
                {({ getFieldValue }) => {
                  const tpid = getFieldValue('tpidNewClient')?.tpid;

                  return (
                    <FormInput
                      name="tpbkidNewClient"
                      comcode="tpbkidNewClient"
                      col
                      md={24}
                    >
                      <BankAccountListSelect
                        params={{ tpid: tpid }}
                        onSelected={(e) =>
                          form?.setFieldsValue({
                            bknew: e.tpbankname + ' - ' + e.tpiban,
                          })
                        }
                        disabled={state.isModSelected}
                      />
                    </FormInput>
                  );
                }}
              </Form.Item>
              <FormInput col md={24} name="newoutstanding">
                <Value
                  formatter={() =>
                    toCurrency(
                      form?.getFieldValue('newoutstanding'),
                      contracts ? contracts[0]?.currcode : ''
                    )
                  }
                />
              </FormInput>
              <FormInput col md={24} name="newrental">
                <Value
                  formatter={() =>
                    toCurrency(
                      form?.getFieldValue('newrental'),
                      contracts ? contracts[0]?.currcode : ''
                    )
                  }
                />
              </FormInput>
              <FormInput
                col
                xs={24}
                name="feesFormula"
                //rules={[{ required: true }]}
              >
                <PricingListFilteredSelect
                  //disabled={!getFieldValue('offerid')}
                  allowClear
                  disabled={state.isModSelected}
                  onChange={(e) => calculateFees(e)}
                  params={{
                    offerid:
                      contracts !== undefined && contracts.length > 0
                        ? contracts[0]?.offerid
                        : 0,
                    ctetype: 'MODFEES', // Modifictaion fees
                    prcode:
                      contracts !== undefined && contracts.length > 0
                        ? contracts[0]?.prcode
                        : '',
                    entity: '',
                    entityid: 0,
                    tpid:
                      contracts !== undefined && contracts.length > 0
                        ? contracts[0]?.tpidclient
                        : 0,
                    filtersValue: '',
                  }}
                  onClear={() => {
                    form?.setFieldValue('feesAmount', 0);
                  }}
                />
              </FormInput>
              <FormInput col xs={24} name="feesAmount" shouldUpdate>
                <InputCurrency
                  currcode={contracts ? contracts[0]?.currcode : 'EUR'}
                  defaultValue={0}
                  disabled={
                    state.isModSelected ||
                    form?.getFieldValue('feesFormula') === undefined
                  }
                />
              </FormInput>
              <FormInput
                col
                xs={24}
                name="comment"
                rules={[{ required: true }]}
              >
                <TextArea rows={4} />
              </FormInput>
            </Col>
          </Row>
          <Row gutter={50}></Row>
        </Form>
      </Spin>
    </DF.Provider>
  );
};

export default TabContractTransfer;
